// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"374":"cfe2fd8df1757ca1","432":"92e8f7ca87424efd"}[chunkId] + ".js";
};